export const icon = {
  fontSize: '150%',
  marginRight: 10,
  color: 'red'
};

export const pageTitle = { fontSize: 30 };
export const titleButton = { marginRight: 8 };
